import _service from '@/modules/student-compu-history/api';

import { MUTATION_TYPES, ACTION_TYPES } from './types';

const actions = {
  async [ACTION_TYPES.GET_FILTERS]({ commit }, studentSieId) {
    const requests = [
      await _service.fetchCompuAcademicYears(studentSieId),
      await _service.fetchCompuMeetingTypes(),
    ];

    const [academicYears, meetingTypes] = await Promise.all(requests);
    commit(MUTATION_TYPES.SET_ACADEMICYEARS, academicYears);
    commit(MUTATION_TYPES.SET_MEETINGTYPES, meetingTypes);
  },

  async [ACTION_TYPES.GET_RESULTS_FILTERED](context, filters) {
    //set current filters
    if (filters == undefined) {
      filters = context.state.currentFilters; //Search for the lastest filters
    } else {
      context.commit(MUTATION_TYPES.SET_CURRENT_FILTERS, filters);
    }

    const response = await _service.fetchStudentCompuHistory(
      filters,
      context.getters.getPagination?.perPage ?? 10
    );
    if (response) {
      context.commit(MUTATION_TYPES.SET_RESULTS_FILTERED, response);
    }
  },
};

export default actions;
